import routeConstants from '../../../Routes/routeConstants';

const getNavItems = (
    user,
    translation,
    companyReportLocation,
    searchStatsLocation,
    companyStatsLocation,
    leadsStatsLocation,
    impressionStatsLocation,
) => [
    {
        path: routeConstants.COMPANY_REPORT,
        location: companyReportLocation,
        key: routeConstants.COMPANY_REPORT,
        text: translation.COMPANY_REPORT,
        visible: user.isBasicUser,
    },
    {
        path: routeConstants.SEARCH_STATS,
        location: searchStatsLocation,
        key: routeConstants.SEARCH_STATS,
        text: translation.SEARCH_WORDS,
        visible: user.isBasicUser,
    },
    {
        path: null,
        key: 'ANALYSIS_MENU',
        text: translation.ANALYSIS,
        isStatisticUserView: true,
        visible: user.isAnalyzeUser,
        subItems: [
            {
                path: routeConstants.COMPANY_STATS,
                location: companyStatsLocation,
                key: routeConstants.COMPANY_STATS,
                text: translation.COMPANY,
            },
            {
                path: routeConstants.LEADS_STATS,
                location: leadsStatsLocation,
                key: routeConstants.LEADS_STATS,
                text: translation.LEADS,
            },
            {
                path: routeConstants.IMPRESSION_STATS,
                location: impressionStatsLocation,
                key: routeConstants.IMPRESSION_STATS,
                text: translation.IMPRESSIONS,
            },
        ],
    },
];

export default getNavItems;
